const STEP_ACTIVE_BG = '#7C3AED'
const STEP_INACTIVE_BG = '#E5E7EB'
const STEP_ACTIVE_TEXT = '#FFFFFF'
const STEP_INACTIVE_TEXT = '#6B7280'

const StepIndicator = ({ steps, current }) => (
  <div className="mb-2 flex items-center justify-center">
    {steps.map((step, idx) => {
      const done = current > step.id
      const active = current === step.id
      const filled = done || active

      return (
        <div key={step.id} className="flex items-center">
          <div className="flex items-center gap-1.5">
            <div
              className={[
                'flex h-6 w-6 items-center justify-center rounded-full text-xs font-semibold transition-colors',
                active ? 'ring-2 ring-brand-100' : '',
              ].join(' ')}
              style={{
                backgroundColor: filled ? STEP_ACTIVE_BG : STEP_INACTIVE_BG,
                color: filled ? STEP_ACTIVE_TEXT : STEP_INACTIVE_TEXT,
              }}
            >
              {done ? '✓' : step.id}
            </div>
            <span
              className={[
                'text-xs font-medium',
                active ? 'text-brand-700' : done ? 'text-brand-600' : 'text-gray-500',
              ].join(' ')}
            >
              {step.label}
            </span>
          </div>
          {idx < steps.length - 1 && (
            <div
              className="mx-2 h-px w-8 transition-colors"
              style={{ backgroundColor: done ? STEP_ACTIVE_BG : 'var(--gray-400)' }}
            />
          )}
        </div>
      )
    })}
  </div>
)

export default StepIndicator
